import { AddAlert } from '../../../../component';
import { Store } from '../../../../helpers';
import { loaded, loading } from '../../../../layout/redux/layoutActions';
import { signTermsOfUse } from '../../../useCases/termsOfUse';

export const acceptTermsOfUse = (
  version: { version: string },
  onTermsOfUseAccept: () => void
) => {
  Store.dispatch(loading());
  signTermsOfUse(version)
    .then((response) => {
      Store.dispatch(AddAlert('success', 'Termos de uso aceito com sucesso!'));
      onTermsOfUseAccept();
    })
    .catch((error) => {
      console.error(error);
      Store.dispatch(AddAlert('error', 'Erro ao aceitar os termos de uso.'));
    })
    .finally(() => {
      Store.dispatch(loaded());
    });
};

export const getTermsOfUse = () =>
  JSON.parse(sessionStorage.getItem('terms_of_use') || '{}');
